import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import EmailTemplateLibrary from '../components/EmailTemplateLibrary'
import QuickResponses from '../components/QuickResponses'

const EmailTemplatesPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="Email Templates"
        subtitle="Professional templates and quick responses"
      />
      
      <div className="page-content">
        <div className="templates-layout">
          <div className="main-section">
            <EmailTemplateLibrary />
          </div>
          
          <div className="sidebar-section">
            <QuickResponses />
          </div>
        </div>
      </div>
    </AppContainer>
  )
}

export default EmailTemplatesPage